import CssBaseline from "@mui/material/CssBaseline";
import { makeStyles } from "@mui/styles";
import React from "react";
import Layout from "./Layout";
import SnackbarProvider from "../Hooks/Snackbar/SnackbarProvider";
import DialogProvider from "../Hooks/Dialog/DialogProvider";

const useStyles = makeStyles(() => ({
    root: {
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column"
    }
}));

const App: React.FC = () => {
    const classes = useStyles();

    return (
        <SnackbarProvider>
            <DialogProvider>
                <div className={classes.root}>
                    <CssBaseline />
                    <Layout />
                </div>
            </DialogProvider>
        </SnackbarProvider>
    );
};

export default App;
